import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-473811fc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "找回账号或密码", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_GetAccountFormVue = _resolveComponent("GetAccountFormVue");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.loginService.getAccountVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.loginService.getAccountVisible = $event;
    }),
    "destroy-on-close": true,
    "mask-closable": false,
    keyboard: false,
    width: 432,
    title: null,
    footer: null,
    "body-style": {
      padding: '0 35px 34px 35px'
    },
    class: "login-dialog show-shadow"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, [_hoisted_1, _createVNode(_component_GetAccountFormVue)])];
    }),
    _: 1
  }, 8, ["visible"]);
}